import { firebase } from '@firebase/app'
import '@firebase/storage'
import { Button, makeStyles } from '@material-ui/core'
import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSession } from 'components/session/session'
import { useClient } from 'components/session/clientSession'
import { useClientTask } from 'components/session/clientTaskSession'
import ImageComponent from '../createTask/taskImageComponent'
import { localize } from 'components/localization/strings'

const useStyles = makeStyles(() => ({
  all: {
    width: '100%',
    marginBottom: '10px'
  },
  video: {
    height: '400px'
  },
  pdf: {
    height: '800px'
  },
  button: {
    marginBottom: '10px',
    marginTop: '10px',
    backgroundColor: 'var(--button-color)',
    color: 'var(--button-text-color)',
    '&:hover': {
      backgroundColor: 'var(--button-color)',
    }
  },
}))


export default function RenderImage({ elmIndex, elm }) {
  const classes = useStyles()
  const session = useSession()
  const clientSession = useClient()
  const clientTaskSession = useClientTask()

  const value = elm.Prompt || ''
  const [content, setContent] = useState(null)
  useEffect(() => {
    if (value && !value.startsWith('data:')) {
      const fileRef = firebase.storage().ref(value)
      fileRef.getDownloadURL().then(fileURI => {
        const filename = fileURI.split('?')[0]
        if (filename.match(/.(jpg|jpeg|png|gif|webp|svg)$/i)) {
          setContent(<img style={{ maxWidth: '100%' }} src={fileURI} />)
        } else if (filename.match(/.(mp4|ogg|webm)$/i)) {
          setContent(<video controls src={fileURI} className={`${classes.all} ${elm.PreserveVideoAspectRatio && (session.external || clientSession.forceClientView) ? '' : `${classes.video}`}`} />)
        } else if (filename.match(/.(mp3|wav)$/i)) {
          setContent(<audio controls src={fileURI} className={`${classes.all}`} />)
        } else if (filename.match(/.(pdf)$/i)) {
          setContent(<embed src={fileURI} type="application/pdf" className={`${classes.all} ${classes.pdf}`} />)
        } else {
          setContent(<Button href={fileURI} size="large" className={classes.button} target='_blank' rel='nofollow'>{localize('Download', clientSession?.client?.Language)} {filename.split('~~~')?.[1] ?? ''}</Button>)
        }
      }).catch(err => {
        console.error(err)
        setContent(<></>)
      })
    } else {
      setContent(<img style={{ maxWidth: '100%' }} src={value} />)
    }
  }, [classes, value])
  if ((session.external || clientSession.forceClientView) || !clientTaskSession.taskRef) return <div key={elmIndex}>{content ?? <></>}</div>
  else {
    const taskRef = clientTaskSession.taskRef
    return <div style={{ border: '1px solid var(--card-text)', padding: '10px' }}>
      {elmIndex + 1})
      <ImageComponent live filepath={`${session.org.ref.id}/${clientSession.clientRef.id}/Tasks/${taskRef.id}`} component={elm} save={(newTaskData) => {
        const Components = clientTaskSession.task.Components
        Components[elmIndex] = newTaskData
        taskRef.set({ Components }, { merge: true }).then(async () => {
          taskRef.get().then(snap => taskRef.collection('Versions').doc().set(snap.data()))
        })
      }} />
    </div>
  }
}

RenderImage.propTypes = {
  elmIndex: PropTypes.number.isRequired,
  elm: PropTypes.object.isRequired
}